import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<circle cx=\"12\" cy=\"12\" r=\"9.5\" stroke=\"currentColor\"></circle><path d=\"M7 10.5H5.5L4.5 11.5L5 13L6 16V19L7.5 20L7 19.5L7.5 17.5L8.5 16L10 14.5L10.5 12.5L10 12L8.5 11.5L7 10.5Z\" fill=\"currentColor\"></path><path d=\"M15 6.5L15.5 7.5L17.5 7L17 6H19L20.5 8.5L19 7.5L18 8L20 10L18.5 12V13.5L17.5 16L16 16.5L15.5 14.5V13L14.5 11H13L12 10.5V8L15 6.5Z\" fill=\"currentColor\"></path><path d=\"M12.5 4V3H14.5L16.5 4L18 5L16 6L14.5 5.5L13.5 6.5H12.5V6V5.5L13.5 5V4.5L12.5 4Z\" fill=\"currentColor\"></path><path d=\"M8.5 4L8 3.5H7.5L4.5 5.5L3 8L5 8.5V7L7 5H9L8.5 4Z\" fill=\"currentColor\"></path>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_7))
}
export default { render: render }